import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconRefresh = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconRefresh"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M3.07 9.742a.1.1 0 0 0-.007.038 10.8 10.8 0 0 0-.189 2.042v.564l-.979-.97a.93.93 0 0 0-.726-.264 1.3 1.3 0 0 0-.82.357 1.2 1.2 0 0 0-.272 1.27q.083.203.24.358l2.904 2.881q.18.151.392.251c.135.061.281.094.43.094.145 0 .29-.032.422-.094q.206-.092.366-.251l2.874-2.88a1 1 0 0 0 .347-.8 1.13 1.13 0 0 0-.347-.834 1.27 1.27 0 0 0-.745-.344.98.98 0 0 0-.8.251l-.979.971v-.564a7.6 7.6 0 0 1 2.43-5.727 8.23 8.23 0 0 1 5.874-2.316 8.04 8.04 0 0 1 5.1 1.71A8.12 8.12 0 0 1 21.789 12a8.35 8.35 0 0 1-8.335 8.31 1.12 1.12 0 0 0-1.066.68 1.1 1.1 0 0 0 1.027 1.51 10.5 10.5 0 0 0 10.37-12.614v-.012a10.61 10.61 0 0 0-20.716-.132" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconRefresh);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
